/**
 * Submit-an-event template
 * This file contains logic specific to a template.
 * It is intended to ONLY be loaded on templates that require
 * this specific functionality.
 **/

import Global from './lib/global';
import Logger from './lib/logger';

// Vars
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

const NAME = 'Submit-an-event';

// Logic
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

/**
 * init - Initialize the page
 **/
const init = () => {
	Logger.log(`${NAME} > loaded`);
	initPhotoUploadField();
}

/**
 * initPhotoUploadField - Initialize the photo upload field
 */
function initPhotoUploadField() {
	Logger.info(`${NAME} > initPhotoUploadField`);
	const photoUploadFieldDom = document.querySelector('[data-photo-upload-field]');
	if (!photoUploadFieldDom) return;

	// Get the input field
	const inputFieldDom = photoUploadFieldDom.querySelector('input[type="file"]');
	if (!inputFieldDom) return;

	// Get the upload area
	const uploadAreaDom = photoUploadFieldDom.querySelector('.submit-an-event-form__upload-area');
	if (!uploadAreaDom) return;

	// Add event listener to the input field
	// When the user selects a file do the following:
	// - Make sure the file is an image
	// - Make sure the file is less than 5MB
	// - If valid, show the image preview with the image as the background image

	inputFieldDom.addEventListener('change', (event) => {
		Logger.info(`${NAME} > inputFieldDom changed`);

		// If the input has an image:
		if (inputFieldDom.value) {
			const file = event.target.files[0];
			if (!file) {
				Logger.info(`${NAME} > no file selected`);
				return;
			}

			// Make sure the file is an image
			if (!file.type.startsWith('image/')) {
				Logger.info(`${NAME} > file is not an image`);
				alert('Please select an image file.');
				return;
			}

			// Make sure the file is less than 5MB
			if (file.size > 5 * 1024 * 1024) {
				Logger.info(`${NAME} > file is too large`);
				alert('Please select an image file less than 5MB.');
				return;
			}

			// If valid, show the image preview with the image as the background image
			const imagePreviewDom = photoUploadFieldDom.querySelector('[data-photo-upload-preview]');
			if (!imagePreviewDom) {
				Logger.info(`${NAME} > no image preview dom found`);
				return;
			}
			imagePreviewDom.innerHTML = `<img src="${URL.createObjectURL(file)}" alt="Event Location Image">`;
			uploadAreaDom.classList.add('submit-an-event-form__upload-area--has-image');
			removeButtonDom.classList.add('submit-an-event-form__upload-area-remove--active');
		} else {
			uploadAreaDom.classList.remove('submit-an-event-form__upload-area--has-image');
			removeButtonDom.classList.remove('submit-an-event-form__upload-area-remove--active');
		}
	});

	// Add event listener to the remove button
	const removeButtonDom = photoUploadFieldDom.querySelector('[data-photo-upload-remove]');
	if (!removeButtonDom) return;

	removeButtonDom.addEventListener('click', () => {
		Logger.info(`${NAME} > remove button clicked`);
		const imagePreviewDom = photoUploadFieldDom.querySelector('[data-photo-upload-preview]');
		if (!imagePreviewDom) {
			Logger.info(`${NAME} > no image preview dom found`);
			return;
		}
		imagePreviewDom.innerHTML = '';
		uploadAreaDom.classList.remove('submit-an-event-form__upload-area--has-image');
		removeButtonDom.classList.remove('submit-an-event-form__upload-area-remove--active');
		inputFieldDom.value = '';
	});
}

// Bootstrap global functionality
Global();

// Bootstrap page-specific functionality
init();

// Do not edit below this line...
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
Logger.log(`${NAME} > loaded`);
